import { LdCrumb, LdTypo } from "@emdgroup-liquid/liquid/dist/react";
import styled from "@emotion/styled";

const StyledStickyContainer = styled.div<{ zIndex?: number }>`
  position: sticky;
  top: 0;
  z-index: ${({ zIndex = 0 }) => zIndex};
`;

const StyledContainer = styled.div<{ zIndex?: number }>`
  z-index: ${({ zIndex = 0 }) => zIndex};
  width: 100%;
  background-color: #503291;
  padding: 10px;
  border-top: 1px solid white;
`;

const StyledCrumbHome = styled(LdCrumb)`
  color: white;

  &::part(link) {
    cursor: default;
    pointer-events: none;
  }
`;

const StyledCrumbText = styled(LdTypo)`
  color: white;
`;

export {
  StyledStickyContainer,
  StyledContainer,
  StyledCrumbText,
  StyledCrumbHome,
};
